import * as React from 'react'
import {Button, Checkbox, Col, Form, Icon, Input, Row, Select, Tooltip} from 'antd';
import {WithTranslation} from 'react-i18next';
import {CompanyItem} from 'src/stores/companies-store';
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import LabelIcon from '../../../components/editable-tooltip/label-icon';
import Tour from 'reactour';
import steps from 'src/components/virtual-tour/virtual-tour-configs';
import RestrictionPlansEditor from 'src/components/restriction-plans-editor';
import TenantSelector from 'src/components/tenant-selector';
import {userHasRole, UserProfileProps} from "../../../components/user-profile";

let FormItem = Form.Item;

interface ClassFormBodyProps extends WithTranslation, UserProfileProps {
    item: CompanyItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldValue(fieldName: string): any;
    openRestrictionPlanAddModal: () => void
    disabled?: boolean
}

interface CompanyViewState {
    value?: string,
    isTourOpen: boolean;
}

export class CompanyFormBody extends React.Component<ClassFormBodyProps, CompanyViewState> {

    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
            value: props.item ? props.item.id : undefined,
            isTourOpen: false,
        }
    }

    componentDidUpdate(prev: ClassFormBodyProps) {
        if (prev.item != this.props.item) {
        }
    }

    static getDerivedStateFromProps(props: ClassFormBodyProps, state: CompanyViewState) {
        let item = props.item as any;
        if (item.id != state.value) {
            return {
                ...state,
                value: item.id
            };
        }
        return state;
    }

    @autobind
    private setIsTourOpen(state: boolean) {
        this.setState({ isTourOpen: state });
    }

    render() {
        const { t } = this.props;
        const { Option } = Select;
        var item = this.props.item || {} as CompanyItem;

        return <Form id="modaForm" onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={0}>
                <Col span={12}>
                    <Tour
                        steps={steps(t).stepsCompany}
                        isOpen={this.state.isTourOpen}
                        onRequestClose={() => this.setIsTourOpen(false)}
                    />
                </Col>
                <Col span={12}>
                    <Button data-tut="reactour__companyInit" type={ "link" } style={{ float: 'right' }} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}> {t("Discover Company")} </Button>
                </Col>
            </Row>
            <Row gutter={24} data-tut="reactour__navegateCompany1">
                <Col span={12}>
                    <FormItem label={t("Company Name")}>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('title'), {
                            initialValue: item.title,
                            rules: [
								{ max : 255 },
                                { required: true, message: t('Name required') },
                                { whitespace: true, message: t('Name required') }],
                        })(
                            <Input placeholder={t("Name")} type="text" disabled={this.props.disabled} maxLength={255} />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <EditableTooltip name='company-reference' noIcon>
                        <FormItem label={<LabelIcon >{t("Reference")}</LabelIcon>}
                        >
                            {this.props.getFieldDecorator(nameof<CompanyItem>('reference'), {
                                initialValue: item.reference,
                                rules: [{ required: false, message: t('Reference required') }],
                            })(
                                <Input placeholder={t('Optional reference')} type="text" disabled={this.props.disabled}/>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>
            <Row gutter={24} data-tut="reactour__navegateCompany1">
                <Col span={12}>
                    <FormItem label={t("Tenant")}>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('tenantId'), {
                            initialValue: { 'value':item.tenantId, 'label':item.tenantName },
                            rules: [
                                { required: true, message: t('Tenant required') }
                                ],
                        })(
                            <TenantSelector loadTenantId={true} />
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={20}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('generateTimesheetTasks'), {
                            rules: [],
                            initialValue: item.generateTimesheetTasks,
                            valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{t("Generate timesheets tasks automatically")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('cloneTimesheetManual'), {
                            rules: [],
                            initialValue: item.cloneTimesheetManual,
                            valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{t("Clone timesheets manually")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col> 
                <Col span={10}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('isInactive'), {
                            rules: [],
                            initialValue: item.isInactive,
                            valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}>
                                <span>{t("Inactive")}</span>
                                <Tooltip title={t("inactive_company_clarification")}><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /> </Tooltip>
                            </Checkbox>
                        )}
                    </FormItem>
                </Col>
                {/*<Col span={12}>*/}
                {/*    <FormItem>*/}
                {/*        {this.props.getFieldDecorator(nameof<CompanyItem>('hoursManagerUsers'), {*/}
                {/*            rules: [],*/}
                {/*            initialValue: item.hoursManagerUsers,*/}
                {/*            valuePropName: 'checked'*/}
                {/*        })(*/}
                {/*            <Checkbox disabled={this.props.disabled}><span>{t("Hours manager for users")}</span></Checkbox>*/}
                {/*        )}*/}
                {/*    </FormItem>*/}
                {/*</Col>                 */}               
            </Row>
            <FormItem label={<EditableTooltip name="company-form-working-regime"> {t("Select default restriction plan")} </EditableTooltip>}>

                <Row gutter={24} data-tut="reactour__navegateCompany2">
                    <Col span={13}>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('defaultRestrictionPlanId'), {
                            initialValue: item.defaultRestrictionPlanId,
                            rules: [],
                        })(
                            <RestrictionPlansEditor
                                value={item.defaultRestrictionPlanId}
                                placeholder={t("No plan selected")}
                                companyId={item.id}
                                disabled={!userHasRole(this.props.userProfile, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"])}
                            />
                        )}
                    </Col>
                    <Col span={1}>
                    <Button disabled={this.props.disabled} style={{ marginTop: '4px', marginRight: '20px', marginLeft:-34 }} icon="plus" onClick={this.props.openRestrictionPlanAddModal} />
                    </Col >
                </Row>
            </FormItem>
            <FormItem label={t("Currency")}>
                <Row gutter={24} >
                    <Col span={12}>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('currency'), {
                            initialValue: item.currency || "EUR",
                            rules: [],
                        })(
                            <Select disabled={this.props.userProfile && this.props.userProfile.roles && this.props.userProfile.roles.includes("CompanyDataViewer")}>
                                <Option value={"USD"} key={"USD"}> {t("USD")} </Option>
                                <Option value={"EUR"} key={"EUR"}> {t("EUR")} </Option>
                                <Option value={"BRL"} key={"BRL"}> {t("BRL")} </Option>
                                <Option value={"GBP"} key={"GBP"}> {t("GBP")} </Option>
                            </Select>
                        )}
                    </Col>
                </Row>
            </FormItem>
            <Row gutter={24}>
                <Col span={12}>
                    <EditableTooltip name="change-company-CIR-eligible" noIcon>
                        <FormItem label={t("Eligibility for CIR / CII")}>
                            {this.props.getFieldDecorator(nameof<CompanyItem>('cirEligible'), {
                                rules: [], initialValue: item.cirEligible, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.disabled}><span>{t("CIR Eligibility")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
                <Col span={12}>
                    <EditableTooltip name="change-company-CII-eligible" noIcon>
                        <FormItem style={{ marginTop: "39px" }} >
                            {this.props.getFieldDecorator(nameof<CompanyItem>('ciiEligible'), {
                                rules: [], initialValue: item.ciiEligible, valuePropName: 'checked'
                            })(
                                <Checkbox  disabled={this.props.disabled}><span>{t("CII Eligibility")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={t("Select available formats for timesheet reports") }>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('standardReport'), {
                            rules: [], initialValue: item.standardReport, valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{t("Standard Format")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('matrixReport'), {
                            rules: [], initialValue: item.matrixReport, valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{t("Matrix Format")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('monthlyReport'), {
                            rules: [], initialValue: item.monthlyReport, valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{`${t("Monthly Format")} (Lei do Bem App)`}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('quarterlyReport'), {
                            rules: [], initialValue: item.quarterlyReport, valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{`${t("Quarterly Format")} (Lei do Bem App)`}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<CompanyItem>('anualReport'), {
                            rules: [], initialValue: item.anualReport, valuePropName: 'checked'
                        })(
                            <Checkbox disabled={this.props.disabled}><span>{`${t("Anual Format")} (Lei do Bem App)`}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
            </Row>
        </Form>
    }
}